import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('league', true); // Get current user parameter

        // User state form configuration
        const estado_usuario = {
            view: 'form',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            id: 'estadoUsuario',
            rows: [
                { view: 'label', label: _('Estado de Usuario') }, // Label for user state
                {
                    css: 'centrar',
                    id: 'StateSwith', // Switch for user state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency state form configuration
        const estado_contingencia = {
            view: 'form',
            id: 'Contingency',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia') }, // Label for contingency state
                {
                    id: 'StateContingencySwith', // Switch for contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencySwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencySwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencySwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency sports state form configuration
        const estado_contingenciaDeportivas = {
            view: 'form',
            id: 'ContingencyDeportivas',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Deportivas') }, // Label for sports contingency state
                {
                    id: 'StateContingencyDeportivasSwith', // Switch for sports contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyDeportivasSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyDeportivasSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyDeportivasSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency casino state form configuration
        const estado_contingenciaCasino = {
            view: 'form',
            id: 'ContingencyCasino',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Casino') }, // Label for casino contingency state
                {
                    id: 'StateContingencyCasinoSwith', // Switch for casino contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyCasinoSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyCasinoSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyCasinoSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency live casino state form configuration
        const estado_contingenciaCasinoVivo = {
            view: 'form',
            id: 'ContingencyCasinoVivo',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Contingencia Casino en Vivo') }, // Label for live casino contingency state
                {
                    id: 'StateContingencyCasinoVivoSwith', // Switch for live casino contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyCasinoVivoSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyCasinoVivoSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyCasinoVivoSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency virtual state form configuration
        const estado_contingenciaVirtuales = {
            view: 'form',
            id: 'ContingencyVirtuales',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia Virtuales') }, // Label for virtual contingency state
                {
                    id: 'StateContingencyVirtualesSwith', // Switch for virtual contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyVirtualesSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyVirtualesSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyVirtualesSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency poker state form configuration
        const estado_contingenciaPoker = {
            view: 'form',
            id: 'ContingencyPoker',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Estado de Contingencia Poker') }, // Label for poker contingency state
                {
                    id: 'StateContingencyPokerSwith', // Switch for poker contingency state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyPokerSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyPokerSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyPokerSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency IP restriction state form configuration
        const estado_contingenciaRestriccionIP = {
            view: 'form',
            id: 'ContingencyRestriccionIP',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Restricción IP') }, // Label for IP restriction
                {
                    view: 'text',
                    name: 'IP',
                    id: 'IP', // Input for IP address
                    label: _('IP'),
                    labelPosition: 'top',
                    placeholder: _('IP'), // Placeholder for IP input
                },
                {
                    id: 'StateContingencyRestriccionIPSwith', // Switch for IP restriction state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyRestriccionIPSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                        cur_user +
                                        ',"IsActivate":"A","IP":"' +
                                        $$('IP').getValue() +
                                        '"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyRestriccionIPSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyRestriccionIP","Id":' +
                                        cur_user +
                                        ',"IsActivate":"I","IP":"' +
                                        $$('IP').getValue() +
                                        '"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyRestriccionIPSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency Google token state form configuration
        const estado_contingenciaTokenGoogle = {
            view: 'form',
            id: 'ContingencyTokenGoogle',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Token Google') }, // Label for Google token
                {
                    id: 'StateContingencyTokenGoogleSwith', // Switch for Google token state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyTokenGoogleSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyTokenGoogle","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyTokenGoogleSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyTokenGoogle","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyTokenGoogleSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Contingency local token state form configuration
        const estado_contingenciaTokenLocal = {
            view: 'form',
            id: 'ContingencyTokenLocal',
            margin: 10,
            minWidth: 200,
            css: 'secutity',
            rows: [
                { view: 'label', label: _('Token Local') }, // Label for local token
                {
                    id: 'StateContingencyTokenLocalSwith', // Switch for local token state
                    view: 'switch',
                    labelWidth: 55,
                    onLabel: _('Activo'), // Active label
                    offLabel: _('Inactivo'), // Inactive label
                    click: () => {
                        // Click event handler for the switch
                        if ($$('StateContingencyTokenLocalSwith').getValue() == 1) {
                            // If switch is on
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyTokenLocal","Id":' + cur_user + ',"IsActivate":"A"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyTokenLocalSwith').setValue(1); // Set switch to on
                                        },
                                    },
                                );
                        } else {
                            // If switch is off
                            webix
                                .ajax()
                                .headers({
                                    'Content-type': 'application/json', // Set content type
                                })
                                .post(
                                    devConfig.geturlApi() + 'Client/UpdateUserSecurity',
                                    '{"Action":"ContingencyTokenLocal","Id":' + cur_user + ',"IsActivate":"I"}', // Request body
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Error! ')); // Error message
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            webix.message(_('Cambios Realizados')); // Success message
                                            $$('StateContingencyTokenLocalSwith').setValue(0); // Set switch to off
                                        },
                                    },
                                );
                        }
                    },
                },
            ],
        };

        // Return the complete layout configuration
        return {
            rows: [
                {
                    cols: [
                        estado_usuario,
                        estado_contingencia,
                        estado_contingenciaDeportivas,
                        estado_contingenciaCasino,
                    ],
                },
                {
                    cols: [
                        estado_contingenciaCasinoVivo,
                        estado_contingenciaVirtuales,
                        estado_contingenciaPoker,
                        estado_contingenciaRestriccionIP,
                    ],
                },
                {
                    cols: [
                        estado_contingenciaTokenGoogle,
                        estado_contingenciaTokenLocal,
                        { gravity: 2, minWidth: 10 }, // Spacer
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and fetches user data.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const cur_user = this.getParam('league', true); // Get current user parameter
        webix.html.addStyle(
            '.bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }', // Style for red background
        );
        webix.html.addStyle(
            '.bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }', // Style for green background
        );
        webix.ajax().get(
            devConfig.geturlApi() + 'Client/GetClientSpById',
            'id=' + cur_user, // Request to get user data
            {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse response text
                    $$('IP').setValue(text[0].IP); // Set IP value
                    if (text[0].IsActivate == 'A') {
                        $$('StateSwith').setValue(1); // Set user state switch to on
                    } else {
                        $$('StateSwith').setValue(0); // Set user state switch to off
                    }
                    if (text[0].IsActivateContingency == 'A') {
                        $$('StateContingencySwith').setValue(1); // Set contingency state switch to on
                    } else {
                        $$('StateContingencySwith').setValue(0); // Set contingency state switch to off
                    }
                    if (text[0].IsActivateContingencyDeportivas == 'A') {
                        $$('StateContingencyDeportivasSwith').setValue(1); // Set sports contingency switch to on
                    } else {
                        $$('StateContingencyDeportivasSwith').setValue(0); // Set sports contingency switch to off
                    }
                    if (text[0].IsActivateContingencyCasino == 'A') {
                        $$('StateContingencyCasinoSwith').setValue(1); // Set casino contingency switch to on
                    } else {
                        $$('StateContingencyCasinoSwith').setValue(0); // Set casino contingency switch to off
                    }
                    if (text[0].IsActivateContingencyCasinoVivo == 'A') {
                        $$('StateContingencyCasinoVivoSwith').setValue(1); // Set live casino contingency switch to on
                    } else {
                        $$('StateContingencyCasinoVivoSwith').setValue(0); // Set live casino contingency switch to off
                    }
                    if (text[0].IsActivateContingencyVirtuales == 'A') {
                        $$('StateContingencyVirtualesSwith').setValue(1); // Set virtual contingency switch to on
                    } else {
                        $$('StateContingencyVirtualesSwith').setValue(0); // Set virtual contingency switch to off
                    }
                    if (text[0].IsActivateContingencyPoker == 'A') {
                        $$('StateContingencyPokerSwith').setValue(1); // Set poker contingency switch to on
                    } else {
                        $$('StateContingencyPokerSwith').setValue(0); // Set poker contingency switch to off
                    }
                    if (text[0].IsRestrictionIP == 'A') {
                        $$('StateContingencyRestriccionIPSwith').setValue(1); // Set IP restriction switch to on
                    } else {
                        $$('StateContingencyRestriccionIPSwith').setValue(0); // Set IP restriction switch to off
                    }
                    if (text[0].IsTokenGoogle == 'A') {
                        $$('StateContingencyTokenGoogleSwith').setValue(1); // Set Google token switch to on
                    } else {
                        $$('StateContingencyTokenGoogleSwith').setValue(0); // Set Google token switch to off
                    }
                    if (text[0].IsTokenLocal == 'A') {
                        $$('StateContingencyTokenLocalSwith').setValue(1); // Set local token switch to on
                    } else {
                        $$('StateContingencyTokenLocalSwith').setValue(0); // Set local token switch to off
                    }
                    console.log(text); // Log the response
                },
            },
        );
    }
}

// FILE DOCUMENTED
